module.exports = __webpack_public_path__ + "img/img10.dbff9e41.svg";